import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from "@mui/material/TableSortLabel";
export const NoteTable = ({ captionText, headers, rows, noDataMessage }) => {
  const nrows = rows == null ? [] : rows;
  const [order, setOrder] = React.useState("desc");
  const createSortHandler = (property) => (event) => {
    setOrder(order == "asc" ? "desc" : "asc");
  };
  function descendingComparator(a, b, orderBy1, orderBy2) {
    if (b[orderBy1] < a[orderBy1]) {
      return -1;
    }
    if (b[orderBy1] > a[orderBy1]) {
      return 1;
    }
    if (b[orderBy2] < a[orderBy2]) {
      return -1;
    }
    if (b[orderBy2] > a[orderBy2]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy1, orderBy2) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy1, orderBy2)
      : (a, b) => -descendingComparator(a, b, orderBy1, orderBy2);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: "400" }} aria-label="customized table">
        {captionText && <caption>{captionText}</caption>}
        <TableHead sx={{ borderBottom: "2px solid #1B4A83" }}>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell key={index}>
                {header}
                {header === "Date" && (
                  <TableSortLabel
                    active
                    direction={order}
                    onClick={createSortHandler()}
                  ></TableSortLabel>
                )}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {nrows?.length <= 0 && (
            <TableRow>
              <TableCell
                colSpan={headers?.length + 1}
                align="center"
                style={{ height: "80px" }}
              >
                Notes are not added.
                {!noDataMessage && (
                  <>
                    Click "<strong>Add Notes</strong>" to create a new note.
                  </>
                )}
              </TableCell>
            </TableRow>
          )}
          {stableSort(
            nrows,
            getComparator(order, "createdDate", "createdTime")
          ).map((row, rowIndex) => (
            <TableRow key={row?.id}>
              <TableCell>{rowIndex + 1}</TableCell>
              <TableCell>{row?.createdBy}</TableCell>
              <TableCell>{row?.createdDate}</TableCell>
              <TableCell>{row?.createdTime}</TableCell>
              <TableCell style={{ wordBreak: "break-all", maxWidth: "450px" }}>
                {row?.message}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default NoteTable;
